import { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import { Card } from '../components/Card.js';
import { StorySkeleton } from '../components/Skeleton.js';
import { useAuth } from '../contexts/AuthContext.js';
import { useCmsStory } from '../contexts/CmsStoryContext.js';

export const CmsPage = () => {
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (user && location.pathname === '/') {
      void navigate('/feeds');
    }
  }, [user, location.pathname]);

  const state = useCmsStory();
  const [showSkeleton, setShowSkeleton] = useState(false);

  useEffect(() => {
    if (state.status !== 'loading') {
      setShowSkeleton(false);
      return;
    }
    const timeout = window.setTimeout(() => setShowSkeleton(true), 200);
    return () => window.clearTimeout(timeout);
  }, [state.status, location.pathname]);

  if (state.status === 'loading') {
    return showSkeleton ? <StorySkeleton /> : <></>;
  }

  if (state.status === 'not-found') {
    return (
      <Card>
        <div className="text-center">
          <h2 className="text-lg font-medium text-text">Page not found</h2>
          <p className="mt-2 text-sm text-text-secondary">The requested page could not be found.</p>
          <Link to="/" className="mt-4 inline-block text-sm text-text underline">
            Go back home
          </Link>
        </div>
      </Card>
    );
  }

  // Story content is rendered by StoryLayout above this outlet.
  return <></>;
};
